module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('Col', {
    staticStyle: {
      "height": "98%",
      "overflow-y": "auto",
      "width": "303px",
      "margin-left": "-20px"
    },
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasdata),
      expression: "hasdata"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-top": "21px"
    }
  }, _vm._l((_vm.statuslist), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('Row', {
      staticStyle: {
        "margin": "0 auto"
      }
    }, [_c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "1vw",
        "height": "1vw"
      },
      attrs: {
        "src": require("../../../../../static/images/xz2.png")
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "2px",
        "height": "10vh",
        "border-left": "1px dashed #15A37D",
        "margin": "0 auto",
        "margin-top": "-0.4vw"
      }
    })])]), _vm._v(" "), _c('Col', {
      staticClass: "Colrightpanel2",
      attrs: {
        "span": "21"
      }
    }, [_c('div', {
      staticClass: "statustab"
    }, [_c('div', [_c('p', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(item.CREATETIME))])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "timelinelabel",
      style: ('color:white;width:95px;padding:2px 4px;background:' + item.color)
    }, [_c('span', [_vm._v(_vm._s(item.STEPNAME))])])])]), _vm._v(" "), _c('Row', {
      staticStyle: {
        "color": "#000",
        "font-size": "14px"
      }
    }, [_c('Col', {
      staticStyle: {
        "padding": "5px 15px 5px 4px"
      },
      attrs: {
        "span": "24"
      }
    }, [_c('p', [_vm._v("意见:" + _vm._s(item.ADVICE))])])], 1)], 1)], 1)], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasdata),
      expression: "!hasdata"
    }],
    staticClass: "display_row_jc_ac",
    staticStyle: {
      "height": "100%",
      "margin-left": "10px",
      "padding-left": "40px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../../static/images/暂无数据横.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1ebd6b71"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/theme/right/data_download/project_status.vue
// module id = 1069
// module chunks = 1